var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 15",
    fill: "#851A92",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.536 2.333C21.29 1.405 20.533.69 19.58.43 17.869 0 11 0 11 0S4.131 0 2.396.452A2.737 2.737 0 0 0 .44 2.357C0 4.024 0 7.5 0 7.5s0 3.476.464 5.167c.245.928 1.003 1.643 1.956 1.904C4.131 15 11 15 11 15s6.869 0 8.604-.452a2.737 2.737 0 0 0 1.956-1.905c.464-1.667.464-5.167.464-5.167S22 4.024 21.536 2.333ZM8.8 10.714V4.286L14.52 7.5 8.8 10.714Z"
  })));
};

export default SvgYoutube;